import { VideoPlayHoverIcon, VideoPlayIcon } from "@/components/ui/icon";
import { cn } from "@/utils/cn";
import { ComponentPropsWithoutRef, forwardRef } from "react";

interface PlayButtonProps extends ComponentPropsWithoutRef<"button"> {
  className?: string;
}

const PlayButton = forwardRef<HTMLButtonElement, PlayButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "group/button flex items-center justify-center w-10 h-10 bg-white rounded-sm",
          className
        )}
        tabIndex={-1}
        {...props}
      >
        <VideoPlayIcon className="text-[rgba(16,24,40,1)] group-hover/button:text-[rgba(64,70,83,1)] w-6 h-6" />
      </button>
    );
  }
);

PlayButton.displayName = "PlayButton";

export default PlayButton;
